/* eslint-disable */
import React, {PropTypes} from 'react';
import './css/erro.css'
class Erro extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        
        
    }

    render() {
    
    return (
                        <div className="container">
                           <div className="row">
                                <div className="divider"></div>
                                <div className="reasons">
                                    <div className="col-lg-12 col-md-12 col-sm-12 animate_afc d1">
                                        <div className="content-box big ch-item bottom-pad-small">
                                            <div className="ch-info-wrap">
                                                <div className="ch-info">
                                                    <div className="ch-info-front ch-img-1"><i className="fa fa-exclamation-triangle"></i></div>
                                                    <div className="ch-info-back">
                                                    <i className="fa fa-exclamation-triangle"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="content-box-info">
                                            </div>
                                            <div className="content-box-infoServico">
                                                <div className="divider"></div>
                                                    <div className='row central'>
                                                        <h3>{this.props.mensagemErro}</h3>
                                                    </div>
                                            </div>
                                            </div>
                                        </div>
                                                
                                    </div>
                                </div>
                                </div>
                       
   );
  }
}
Erro.contextTypes = {
  router: React.PropTypes.object
};



export default Erro;



/** WEBPACK FOOTER **
 ** ./src/components/Erro.js
 **/